<template>
  <CafeteriaEnlistmentList/>
</template>
<script>
import CafeteriaEnlistmentList from '@/components/modules/cafeteria/enlistment/list'
export default {
  name: 'CafeteriaEnlistment',
  components: {
    CafeteriaEnlistmentList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/enlistment/list.vue